import Vue from 'vue'
import App from './App.vue'
import vueScrollto from "vue-scrollto";
import VueSilentbox from "vue-silentbox";
import VueLazyLoad from 'vue-lazyload';
import VueTouch from 'vue-touch';
import VueCarousel from 'vue-carousel';

Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })

Vue.use(VueSilentbox);

Vue.use(VueCarousel);

Vue.use(vueScrollto);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
